import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Link as RouterLink } from 'react-router-dom'
import Typography from "@material-ui/core/Typography";
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";

import CreditCardForm from "./CreditCardForm.js";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ReCAPTCHA from "react-google-recaptcha";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const VideoSlide1 = () => (
  <div className="video-wrapper">
    <video controls width="60%" height="30%" poster="/static/images/DSC08313.JPG">
      <source src="/static/images/OrchimaWatering.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

const VideoSlide2 = () => (
  <div className="video-wrapper">
    <video controls width="60%" height="30%" poster="/static/images/OrchimaWaterReleasepng.png">
      <source src="/static/images/OrchimaWaterRelease.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

const images = [
  {
    renderItem: () => <VideoSlide1 />,
    thumbnail: "/static/images/DSC08313.JPG",
    originalHeight: "200",
    originalWidth: "200",
    thumbnailHeight: 100,
    thumbnailWidth: 100,
    originalTitle: "Watering Orchima Pot",
    thumbnailTitle: "Watering Orchima Pot",
    thumbnailLabel: "Watering Orchima Pot",
    description: "Watering Orchima Pot",
  },
  {
    renderItem: () => <VideoSlide2 />,
    thumbnail: "/static/images/OrchimaWaterReleasepng.png",
    originalHeight: "200",
    originalWidth: "200",
    thumbnailHeight: 100,
    thumbnailWidth: 100,
    originalTitle: "Releasing water",
    thumbnailTitle: "Releasing water",
    thumbnailLabel: "Releasing water",
    description: "Releasing Water",
  },
];

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  button: {
    margin: theme.spacing.unit,
  },
  multilineColor: {
    color: 'black',
    backgroundColor: '#f5f7e8',
  },
});

// ─── Design tokens ────────────────────────────────────────────────────────────
const GREEN       = '#1a736a';
const GREEN_LIGHT = '#f0f7f5';
const RED         = '#BF360C';
const DARK        = '#1a2e1d';
const GRAY        = '#555';

// ─── Module-level content arrays (keep render() readable) ────────────────────

const BENEFITS = [
  {
    title: 'Consistent watering, every time',
    body:  'The soak-and-drain approach gives roots exactly what they need — no more guessing between too much and not enough.',
  },
  {
    title: 'No Tipping. No Separate Container.',
    body:  'Open the drain and excess water flows out on its own — no tipping the pot, no separate soaking bucket, no mopping up spills.',
  },
  {
    title: 'Everything Happens in One Pot',
    body:  'No removing the liner from a decorative pot. No separate soaking container. Fill, soak, and drain — all in the Orchima™ pot.',
  },
  {
    title: 'A routine simple enough to stick to',
    body:  'Fill → Soak → Drain. Three steps, the same every time. Consistency is what keeps orchids alive.',
  },
  {
    title: 'Confidence from your very first watering',
    body:  'No experience needed. If you can fill a cup with water, you can care for an orchid with Orchima™.',
  },
  {
    title: 'Everything included — ready to use',
    body:  'Orchima™ comes as a complete system. Just add your orchid, growing medium, and water.',
  },
];

const SETUP_STEPS = [
  {
    title: 'Prepare the inner basket',
    body:  'Add a few small stones to the bottom of the inner basket to keep it from floating when water is added.',
    img:   '/static/images/LineWithStones.png',
    ratio: '(6/4)',
  },
  {
    title: 'Add growing medium',
    body:  'Fill the lower part of the basket with orchid bark or your preferred orchid growing mix.',
    tip:   '"Bark" means any suitable orchid growing medium — bark alone, or a blend of bark, charcoal, and perlite.',
    img:   '/static/images/LinerWithBarks.png',
    ratio: '(6/4)',
  },
  {
    title: 'Rinse thoroughly',
    body:  'Rinse the bark well to remove fine particles.',
    tip:   'Tip: Removing fine particles helps keep the drain clear over time.',
    img:   '/static/images/WashingDebrisWithOrchidPlant2.png',
    ratio: '(4/6)',
  },
  {
    title: 'Let it drain',
    body:  'Leave the basket in the sink and allow excess water to drain before assembly.',
    img:   '/static/images/LinerWithPlant.png',
    ratio: '(4/6)',
  },
  {
    title: 'Place the screen at the bottom',
    body:  'Set the round screen at the bottom of the Orchima™ pot before inserting the basket.',
    img:   '/static/images/PotAndLiner.png',
    ratio: '(3/4)',
  },
  {
    title: 'Insert the basket',
    body:  'Lower the planted basket into the Orchima™ pot.',
    img:   '/static/images/PlacingLiner.png',
    ratio: '(3/4)',
  },
  {
    title: 'Ready to use',
    body:  'Your Orchima™ is set up and ready. Begin with Fill → Soak → Drain.',
    img:   '/static/images/OrchimaPotPlant3.png',
    ratio: '(3/4)',
  },
];

const FAQ_ITEMS = [
  {
    q: 'Do I need orchid experience to use Orchima™?',
    a: 'No experience required. Orchima™ was designed specifically for people who are new to orchids. The Fill → Soak → Drain routine is the same every time, so there is nothing to memorize or figure out. If you can fill a cup with water, you can care for an orchid with Orchima™.',
  },
  {
    q: 'What if my orchid came from Costco, Home Depot, or a grocery store?',
    a: 'Orchima™ works well with store-bought orchids — with one note. Many store orchids are packed in sphagnum moss, which can make watering unpredictable. We recommend repotting into orchid bark before using Orchima™. Orchid bark is widely available at garden centers and creates the right conditions for the Fill → Soak → Drain routine to work well.',
  },
  {
    q: 'Is Orchima™ just another orchid pot?',
    a: 'No. A traditional pot holds your plant and leaves the watering entirely up to you. Orchima™ is a complete care system built around a specific, repeatable routine. The built-in drain is what makes the routine possible — you fill, you soak, you open the drain, and the excess water flows out on its own.',
  },
  {
    q: 'Why is Orchima™ different from a traditional clear orchid pot?',
    a: 'Traditional clear pots are popular with experienced growers who like to monitor root health visually. Orchima™ takes a different approach — it replaces the need for visual monitoring with a consistent, repeatable routine. Instead of checking root color or moisture level, you follow the same three steps every time. The routine does the work.',
  },
  {
    q: "Why isn't Orchima™ transparent?",
    a: "Experienced orchid growers often prefer transparent pots so they can monitor root health at a glance. Orchima™ was not designed for experienced growers — it was designed for ordinary people who want to enjoy orchids without that level of monitoring. The Fill → Soak → Drain routine provides consistent, reliable care without needing to inspect the roots.",
  },
];

// ─── Shared inline style helpers ─────────────────────────────────────────────
const section = (bg, extraPad) => ({
  backgroundColor: bg || '#ffffff',
  padding: extraPad || '64px 0',
});

const inner = (maxW) => ({
  maxWidth: maxW || 760,
  margin: '0 auto',
  padding: '0 24px',
});

const eyebrow = (color) => ({
  fontSize: 12,
  fontWeight: 700,
  color: color || GREEN,
  letterSpacing: 2,
  textTransform: 'uppercase',
  textAlign: 'center',
  marginBottom: 14,
});

const sectionHeading = (size) => ({
  fontSize: size || 28,
  fontWeight: 700,
  color: DARK,
  textAlign: 'center',
  lineHeight: 1.3,
  marginBottom: 20,
});

const card = (extra) => Object.assign({
  backgroundColor: '#ffffff',
  borderRadius: 10,
  padding: '24px 22px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
}, extra || {});


class OrchimaMainPage extends Component {

  state = {
    userComment: {},
    selectedUser: {},
    showOrderDialog: false,
    captchaValue: '',
  };

  constructor(props) {
    super(props);
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);
    this.handleClickShowOrderDialogClose = this.handleClickShowOrderDialogClose.bind(this);
    this.handleCaptchaChange = this.handleCaptchaChange.bind(this);
    this.recaptchaRef = React.createRef();
  }

  componentDidMount() {}

  handleShowOrderFormChange = () => {
    this.setState({ showOrderDialog: true });
  };

  handleClickShowOrderDialogClose() {
    this.setState({ showOrderDialog: false });
  }

  handleFirstNameChange(event) {
    this.setState(Object.assign(this.state.userComment, { firstname: event.target.value }));
  }

  handleLastNameChange(event) {
    this.setState(Object.assign(this.state.userComment, { lastname: event.target.value }));
  }

  handleEmailChange(event) {
    this.setState(Object.assign(this.state.userComment, { email: event.target.value }));
  }

  handleCommentChange(event) {
    this.setState(Object.assign(this.state.userComment, { comment: event.target.value }));
  }

  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
  };

  saveVisitorComment() {
    const { saveAComment } = this.props;
    const { firstname, lastname, email, comment } = this.state.userComment;
    if (!firstname) { alert('Please provide your first name!'); return; }
    if (!lastname)  { alert('Please provide your last name!'); return; }
    if (!email)     { alert('Please provide your Email!'); return; }
    if (email.indexOf('@') === -1) { alert('Please provide a valid email address!'); return; }
    if (!comment)   { alert('Please provide your comment!'); return; }
    saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
  }

  render() {
    const { classes } = this.props;

    return (
      <div id="top1" style={{ backgroundColor: '#ffffff', fontFamily: 'inherit' }}>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 1 — HERO
        ══════════════════════════════════════════════════════════════ */}
        <div style={section(GREEN_LIGHT, '64px 0 56px')}>
          <div style={inner(820)}>
            <Typography style={eyebrow()}>
              Patent-Pending Orchid Care System
            </Typography>
            <Typography variant="h3" component="h1"
              style={{ fontSize: 'clamp(24px, 5vw, 36px)', fontWeight: 800, color: DARK, textAlign: 'center', lineHeight: 1.25, marginBottom: 16 }}>
              Enjoy Orchids Without Becoming an Orchid Expert
            </Typography>
            <Typography style={{ fontSize: 20, color: GRAY, textAlign: 'center', lineHeight: 1.7, maxWidth: 580, margin: '0 auto 36px' }}>
              A simpler orchid care system for people who want beautiful orchids at home — without the guesswork.
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
              <div style={{ maxWidth: 260, width: '100%' }}>
                <Zoom>
                  <Image src="/static/images/OrchimaPotPlant3.png" aspectRatio="(3/4)" />
                </Zoom>
                <Typography style={{ textAlign: 'center', color: '#aaa', fontSize: 12, marginTop: 6, fontStyle: 'italic' }}>
                  Click to enlarge
                </Typography>
              </div>
            </div>

            <Typography style={{ fontSize: 34, fontWeight: 800, color: RED, textAlign: 'center', letterSpacing: -0.5, marginBottom: 8 }}>
              Fill &rarr; Soak &rarr; Drain
            </Typography>
            <Typography style={{ fontSize: 15, color: '#888', textAlign: 'center', fontStyle: 'italic', marginBottom: 36 }}>
              Three steps. Same routine every time. No experience needed.
            </Typography>

            <div style={{ maxWidth: 460, margin: '0 auto 40px' }}>
              {[
                'Your orchid gets consistent, reliable water — every time',
                'No tipping, no separate containers, less guesswork',
                'Simple enough to stick to — for anyone',
                'Designed for orchid lovers, not orchid experts',
              ].map((text, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 12 }}>
                  <span style={{ color: GREEN, fontSize: 18, marginRight: 10, lineHeight: '1.55' }}>✓</span>
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.6 }}>{text}</Typography>
                </div>
              ))}
            </div>

            {/* CTA buttons — hidden until ready to sell */}
            <div style={{ display: 'none', textAlign: 'center' }}>
              <Button variant="contained" onClick={this.handleShowOrderFormChange}
                style={{ backgroundColor: GREEN, color: 'white', fontSize: 18, padding: '13px 40px', textTransform: 'none', borderRadius: 6, boxShadow: '0 2px 10px rgba(26,115,106,0.3)', marginRight: 16 }}>
                Request a Sample
              </Button>
              <Button variant="outlined"
                style={{ color: GREEN, borderColor: GREEN, fontSize: 18, padding: '13px 36px', textTransform: 'none', borderRadius: 6 }}>
                See How Orchima Works
              </Button>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 2 — THE PROBLEM (high on page)
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#ffffff')}>
          <div style={inner(700)}>
            <Typography style={eyebrow(RED)}>The Problem</Typography>
            <Typography variant="h4" component="h2"
              style={{ ...sectionHeading(28), color: DARK, marginBottom: 24 }}>
              Most Orchids Don't Die From Neglect&nbsp;—<br />They Die From Inconsistent Watering
            </Typography>
            <Typography style={{ fontSize: 18, color: GRAY, textAlign: 'center', lineHeight: 1.7, maxWidth: 600, margin: '0 auto 36px' }}>
              If you've ever lost an orchid and couldn't figure out why, you're not alone.
              Orchids aren't difficult plants — but they are sensitive to how consistently they're watered.
            </Typography>
            <div style={{ maxWidth: 560, margin: '0 auto' }}>
              {[
                { label: 'Too much water', desc: 'causes root rot — the most common reason orchids die.' },
                { label: 'Too little water', desc: 'causes dehydration and early flower loss.' },
                { label: 'Inconsistent watering', desc: 'stresses the plant over time, even with the best intentions.' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 18 }}>
                  <div style={{ minWidth: 10, height: 10, borderRadius: '50%', backgroundColor: RED, marginTop: 7, marginRight: 14, flexShrink: 0 }} />
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.65 }}>
                    <strong>{item.label}</strong> {item.desc}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 3 — THE SOLUTION
        ══════════════════════════════════════════════════════════════ */}
        <div style={section(GREEN_LIGHT)}>
          <div style={inner(820)}>
            <Typography style={eyebrow()}>The Solution</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(28)}>
              {MainConstants.APPLICATION_NAME}&trade; Gives You a Routine You Can Actually Stick To
            </Typography>
            <Typography style={{ fontSize: 18, color: GRAY, textAlign: 'center', lineHeight: 1.7, maxWidth: 580, margin: '0 auto 16px' }}>
              Instead of guessing, {MainConstants.APPLICATION_NAME}&trade; gives you one simple routine — the same three steps, every time. No experience required.
            </Typography>
            <Typography style={{ fontSize: 38, fontWeight: 800, color: RED, textAlign: 'center', letterSpacing: -0.5, marginBottom: 40 }}>
              Fill &rarr; Soak &rarr; Drain
            </Typography>

            <div style={{ overflow: 'hidden' }}>
              <Grid container spacing={24}>
                {[
                  {
                    n: '1', step: 'Fill',
                    desc: 'Rinse the growing medium at the sink, then close the drain and fill the pot with water or a water-and-fertilizer mixture.',
                  },
                  {
                    n: '2', step: 'Soak',
                    desc: 'Let your orchid drink for 10–15 minutes. Walk away. There is nothing to watch or adjust.',
                  },
                  {
                    n: '3', step: 'Drain',
                    desc: 'Open the drain at the bottom. Excess water flows out on its own — no tipping the pot, no separate container needed.',
                  },
                ].map((s) => (
                  <Grid key={s.n} item xs={12} sm={4}>
                    <div style={card({ textAlign: 'center' })}>
                      <Typography style={{ fontSize: 52, fontWeight: 800, color: GREEN, lineHeight: 1 }}>{s.n}</Typography>
                      <Typography style={{ fontSize: 22, fontWeight: 700, color: GREEN, margin: '8px 0 14px' }}>{s.step}</Typography>
                      <Typography style={{ fontSize: 15, color: GRAY, lineHeight: 1.65 }}>{s.desc}</Typography>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>

            <Typography style={{ fontSize: 19, fontWeight: 700, color: DARK, textAlign: 'center', marginTop: 36 }}>
              That's it. Same routine, every time. No guesswork.
            </Typography>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 4 — JUST BOUGHT AN ORCHID?
        ══════════════════════════════════════════════════════════════ */}
        <div style={{ backgroundColor: '#fffdf4', padding: '56px 0', borderTop: '1px solid #ede8d0', borderBottom: '1px solid #ede8d0' }}>
          <div style={inner(680)}>
            <Typography style={eyebrow('#8a6a00')}>Store-Bought Orchids</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(26)}>
              Just Bought an Orchid?
            </Typography>
            <Typography style={{ fontSize: 18, color: '#444', textAlign: 'center', lineHeight: 1.8, maxWidth: 600, margin: '0 auto' }}>
              Most orchids sold in stores are packaged for shipping and display, not necessarily for long-term home care.{' '}
              {MainConstants.APPLICATION_NAME}&trade; helps transition your orchid into a simple, repeatable watering routine
              designed to support healthier roots and long-term success.
            </Typography>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 5 — WHO IT'S FOR
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#ffffff')}>
          <div style={inner(660)}>
            <Typography style={eyebrow()}>Who It's For</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(26)}>
              {MainConstants.APPLICATION_NAME}&trade; Is For You If&hellip;
            </Typography>
            <div style={{ maxWidth: 540, margin: '0 auto 32px' }}>
              {[
                'You received an orchid as a gift and want to keep it alive',
                "You've bought orchids before and watched them slowly decline — without knowing why",
                "You love beautiful flowers but don't want to become a plant expert",
                'You want a simple, repeatable watering routine that actually works',
                'You picked up an orchid at Costco, Home Depot, or a grocery store and want it to thrive',
              ].map((text, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 16 }}>
                  <span style={{ color: GREEN, fontSize: 20, marginRight: 12, lineHeight: '1.5' }}>✓</span>
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.65 }}>{text}</Typography>
                </div>
              ))}
            </div>
            <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 8, padding: '20px 24px' }}>
              <Typography style={{ fontSize: 15, color: '#555', textAlign: 'center', lineHeight: 1.75, fontStyle: 'italic' }}>
                If you are an experienced orchid grower with a care routine that already works well for you,
                {' '}{MainConstants.APPLICATION_NAME}&trade; may not be necessary.
                But if you have ever bought a beautiful orchid and struggled to keep it thriving,
                {' '}{MainConstants.APPLICATION_NAME}&trade; was designed for you.
              </Typography>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 6 — BENEFITS
        ══════════════════════════════════════════════════════════════ */}
        <div style={section(GREEN_LIGHT)}>
          <div style={inner(900)}>
            <Typography style={eyebrow()}>What It Does For You</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(28)}>
              What {MainConstants.APPLICATION_NAME}&trade; Does For You
            </Typography>

            <Grid container spacing={24}>
              {BENEFITS.map((b, i) => (
                <Grid key={i} item xs={12} sm={6}>
                  <div style={card({ borderLeft: '4px solid ' + GREEN, height: '100%' })}>
                    <Typography style={{ fontSize: 17, fontWeight: 700, color: GREEN, marginBottom: 8 }}>{b.title}</Typography>
                    <Typography style={{ fontSize: 15, color: GRAY, lineHeight: 1.65 }}>{b.body}</Typography>
                  </div>
                </Grid>
              ))}
            </Grid>

            {/* CTA after benefits — hidden until ready to sell */}
            <div style={{ display: 'none', textAlign: 'center', marginTop: 44 }}>
              <Button variant="contained" onClick={this.handleShowOrderFormChange}
                style={{ backgroundColor: GREEN, color: 'white', fontSize: 18, padding: '13px 44px', textTransform: 'none', borderRadius: 6, boxShadow: '0 2px 10px rgba(26,115,106,0.3)' }}>
                Try {MainConstants.APPLICATION_NAME}&trade;
              </Button>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 7 — EARLY FEEDBACK (social proof placeholder)
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#ffffff', '56px 0')}>
          <div style={{ ...inner(600), textAlign: 'center' }}>
            <Typography style={eyebrow()}>Early Feedback</Typography>
            <Typography variant="h4" component="h2" style={{ ...sectionHeading(24), marginBottom: 16 }}>
              We're Gathering Feedback From Orchid Owners
            </Typography>
            <Typography style={{ fontSize: 17, color: GRAY, lineHeight: 1.75, marginBottom: 28 }}>
              We are currently gathering feedback from orchid owners and growers. If you try {MainConstants.APPLICATION_NAME}&trade;,
              we would love to hear about your experience.{' '}
              <a href="/contactus" rel="noreferrer" style={{ color: GREEN, fontWeight: 600 }}>Contact Us</a>
            </Typography>
            {/* CTA — hidden until ready to sell */}
            <div style={{ display: 'none' }}>
              <Button variant="contained" onClick={this.handleShowOrderFormChange}
                style={{ backgroundColor: GREEN, color: 'white', fontSize: 16, padding: '11px 32px', textTransform: 'none', borderRadius: 6 }}>
                Request a Sample
              </Button>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 8 — VIDEOS
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#f8f9f8')}>
          <div style={inner(800)}>
            <Typography style={eyebrow(RED)}>See It in Action</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(26)}>
              Watch How Simple It Really Is
            </Typography>
            <Typography style={{ fontSize: 16, color: GRAY, textAlign: 'center', marginBottom: 32 }}>
              Fill &rarr; Soak &rarr; Drain. Exactly as simple as it sounds.
            </Typography>
            <ImageGallery items={images}
              thumbnailPosition={'bottom'}
              showBullets={true}
              showIndex={true}
              showPlayButton={false}
              showNav={false}
              showFullscreenButton={false} />
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 9 — HOW TO USE (4-step accurate instruction flow)
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#ffffff')}>
          <div style={inner(800)}>
            <Typography style={eyebrow(RED)}>How to Use</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(26)}>
              How to Use {MainConstants.APPLICATION_NAME}&trade;
            </Typography>

            {/* Image disclaimer */}
            <div style={{ backgroundColor: '#f8f9f8', borderRadius: 8, padding: '14px 20px', marginBottom: 40, textAlign: 'center' }}>
              <Typography style={{ fontSize: 14, color: '#888', lineHeight: 1.7, marginBottom: 4 }}>
                <strong style={{ color: '#555' }}>Image Notice:</strong>{' '}
                Images in this section are AI-generated for illustration purposes and are designed to closely represent the {MainConstants.APPLICATION_NAME}&trade; pot.
                The {MainConstants.APPLICATION_NAME}&trade; logo shown in these images is for visual presentation only and is not currently printed on the product.
              </Typography>
              <Typography style={{ fontSize: 14, color: '#888', lineHeight: 1.7 }}>
                For actual product photos, please refer to the images at the top of this page or in the Initial Setup section below.
              </Typography>
            </div>

            {/* Step 1 — Rinse */}
            <div style={{ marginBottom: 44 }}>
              <Grid container spacing={24} alignItems="flex-start">
                <Grid item xs={12} sm={7}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', backgroundColor: GREEN, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: 14 }}>
                      <span style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>1</span>
                    </div>
                    <Typography style={{ fontSize: 24, fontWeight: 700, color: GREEN }}>Rinse</Typography>
                  </div>
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.75, marginBottom: 0 }}>
                    Place the {MainConstants.APPLICATION_NAME}&trade; pot in a sink with the drain valve open.
                    Run water through the top to rinse and refresh the growing medium.
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <div style={{ maxWidth: 180, width: '100%' }}>
                    <Zoom><Image src="/static/images/step1.png" aspectRatio="(4/4)" /></Zoom>
                  </div>
                </Grid>
              </Grid>
            </div>

            <Divider style={{ marginBottom: 44, backgroundColor: '#eeeeee' }} />

            {/* Step 2 — Fill */}
            <div style={{ marginBottom: 44 }}>
              <Grid container spacing={24} alignItems="flex-start">
                <Grid item xs={12} sm={7}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', backgroundColor: GREEN, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: 14 }}>
                      <span style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>2</span>
                    </div>
                    <Typography style={{ fontSize: 24, fontWeight: 700, color: GREEN }}>Fill</Typography>
                  </div>
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.75, marginBottom: 12 }}>
                    Close the drain valve.
                    Fill the pot to the rim with water or a water–orchid fertilizer mixture.
                  </Typography>
                  <Typography style={{ fontSize: 14, color: '#888', fontStyle: 'italic', lineHeight: 1.65 }}>
                    Tip: You may alternate between plain water and diluted orchid fertilizer depending on your care routine and your orchid's needs.
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <div style={{ maxWidth: 180, width: '100%' }}>
                    <Zoom><Image src="/static/images/step3.png" aspectRatio="(4/4)" /></Zoom>
                  </div>
                </Grid>
              </Grid>
            </div>

            <Divider style={{ marginBottom: 44, backgroundColor: '#eeeeee' }} />

            {/* Step 3 — Soak */}
            <div style={{ marginBottom: 44 }}>
              <Grid container spacing={24} alignItems="flex-start">
                <Grid item xs={12} sm={7}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', backgroundColor: GREEN, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: 14 }}>
                      <span style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>3</span>
                    </div>
                    <Typography style={{ fontSize: 24, fontWeight: 700, color: GREEN }}>Soak</Typography>
                  </div>
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.75, marginBottom: 12 }}>
                    Allow the roots and growing medium to soak for up to 15 minutes.
                  </Typography>
                  <Typography style={{ fontSize: 14, color: '#888', fontStyle: 'italic', lineHeight: 1.65 }}>
                    Soaking time may vary depending on your environment, humidity, growing medium, and orchid condition.
                    Walk away — there is nothing to watch or adjust.
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <div style={{ maxWidth: 180, width: '100%' }}>
                    <Zoom><Image src="/static/images/step4.png" aspectRatio="(4/4)" /></Zoom>
                  </div>
                </Grid>
              </Grid>
            </div>

            <Divider style={{ marginBottom: 44, backgroundColor: '#eeeeee' }} />

            {/* Step 4 — Drain */}
            <div style={{ marginBottom: 40 }}>
              <Grid container spacing={24} alignItems="flex-start">
                <Grid item xs={12} sm={7}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', backgroundColor: GREEN, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: 14 }}>
                      <span style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>4</span>
                    </div>
                    <Typography style={{ fontSize: 24, fontWeight: 700, color: GREEN }}>Drain</Typography>
                  </div>
                  <Typography style={{ fontSize: 17, color: '#222', lineHeight: 1.75, marginBottom: 12 }}>
                    Open the bottom drain valve and allow all water to drain completely.
                    This may take a few minutes.
                  </Typography>
                  <Typography style={{ fontSize: 14, color: '#888', fontStyle: 'italic', lineHeight: 1.65 }}>
                    Once drained, the valve may be left open to encourage airflow, or closed before returning the pot to its location.
                    No tipping, no separate container needed — the drain does the work.
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <div style={{ maxWidth: 180, width: '100%' }}>
                    <Zoom><Image src="/static/images/step5.png" aspectRatio="(4/4)" /></Zoom>
                  </div>
                </Grid>
              </Grid>
            </div>

            {/* Marketing summary */}
            <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 10, padding: '24px 28px', marginTop: 12, marginBottom: 32 }}>
              {[
                'No removing liners.',
                'No separate soaking containers.',
                'No tipping to drain.',
              ].map((line, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
                  <span style={{ color: GREEN, fontWeight: 700, marginRight: 8, fontSize: 18 }}>✓</span>
                  <Typography style={{ fontSize: 17, fontWeight: 700, color: GREEN }}>{line}</Typography>
                </div>
              ))}
              <Typography style={{ fontSize: 16, color: DARK, lineHeight: 1.7, marginTop: 10 }}>
                Just a cleaner, more repeatable orchid care routine.
              </Typography>
            </div>

            <Typography style={{ fontSize: 15, color: '#555', lineHeight: 1.65, marginBottom: 28 }}>
              Watering frequency depends on your home environment and humidity.
            </Typography>

            {/* Drain valve quick reference */}
            <div style={{ backgroundColor: '#f8f9f8', borderRadius: 10, padding: '20px 24px' }}>
              <Typography style={{ fontSize: 15, fontWeight: 700, color: DARK, marginBottom: 6 }}>
                Quick Reference: Drain Valve Position
              </Typography>
              <Typography style={{ fontSize: 14, color: '#777', fontStyle: 'italic', marginBottom: 16 }}>
                A horizontal handle = valve closed (use during soaking and filling).
                A vertical handle = valve open (use during rinsing and draining).
              </Typography>
              <Grid container spacing={16}>
                <Grid item xs={6} sm={3}>
                  <Typography style={{ fontSize: 13, color: '#666', fontStyle: 'italic', marginBottom: 6 }}>Open — rinse &amp; drain</Typography>
                  <div style={{ maxWidth: 140, width: '100%' }}>
                    <Zoom><Image src="/static/images/ValveOpen2.png" aspectRatio="(4/4)" /></Zoom>
                  </div>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography style={{ fontSize: 13, color: '#666', fontStyle: 'italic', marginBottom: 6 }}>Closed — fill &amp; soak</Typography>
                  <div style={{ maxWidth: 140, width: '100%' }}>
                    <Zoom><Image src="/static/images/ValveClose.png" aspectRatio="(4/4)" /></Zoom>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 10 — INITIAL SETUP
        ══════════════════════════════════════════════════════════════ */}
        <div style={section(GREEN_LIGHT)}>
          <div style={inner(820)}>
            <Typography style={eyebrow(RED)}>Getting Started</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(26)}>
              Initial Setup: Planting Your Orchid
            </Typography>

            <div style={card({ borderLeft: '4px solid ' + GREEN, marginBottom: 32 })}>
              <Typography style={{ fontSize: 16, fontWeight: 700, color: DARK, marginBottom: 8 }}>Before You Begin</Typography>
              <Typography style={{ fontSize: 16, color: '#444', lineHeight: 1.75 }}>
                This system works best with a bark-based orchid growing mix — bark alone, or a blend of bark, charcoal, and perlite.
                If your orchid is already in a well-ventilated container with good airflow, you may be able to skip repotting
                and place it directly into the {MainConstants.APPLICATION_NAME}&trade; pot.
              </Typography>
            </div>

            <Typography style={{ fontSize: 13, color: '#aaa', textAlign: 'right', fontStyle: 'italic', marginBottom: 20 }}>
              Click any photo to enlarge
            </Typography>

            <ol style={{ paddingLeft: 20 }}>
              {SETUP_STEPS.map((step, i) => (
                <li key={i} style={{ marginBottom: 36 }}>
                  <Grid container spacing={24} alignItems="flex-start">
                    <Grid item xs={12} sm={7}>
                      <Typography style={{ fontSize: 17, fontWeight: 700, color: DARK, marginBottom: 6 }}>{step.title}</Typography>
                      <Typography style={{ fontSize: 16, color: '#333', lineHeight: 1.7, marginBottom: step.tip ? 8 : 0 }}>{step.body}</Typography>
                      {step.tip && (
                        <Typography style={{ fontSize: 14, color: '#888', fontStyle: 'italic', lineHeight: 1.6 }}>{step.tip}</Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <div style={{ maxWidth: 180, width: '100%' }}>
                        <Zoom><Image src={step.img} aspectRatio={step.ratio || '(4/4)'} /></Zoom>
                      </div>
                    </Grid>
                  </Grid>
                </li>
              ))}
            </ol>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 11 — OUR MISSION
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#ffffff', '56px 0')}>
          <div style={{ ...inner(640), textAlign: 'center' }}>
            <Typography style={eyebrow()}>Our Mission</Typography>
            <Typography style={{ fontSize: 18, color: '#333', lineHeight: 1.85 }}>
              {MainConstants.APPLICATION_NAME}&trade; was created to make orchid care more accessible.
              By giving beginners a simple, repeatable routine, {MainConstants.APPLICATION_NAME}&trade; helps ordinary
              people succeed with orchids — and gain the confidence to keep them thriving.{' '}
              <span style={{ color: RED, fontWeight: 600, whiteSpace: 'nowrap' }}>
                Your orchid deserves better than trial and error.
              </span>
            </Typography>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            SECTION 12 — FAQ
        ══════════════════════════════════════════════════════════════ */}
        <div style={section('#f8f9f8')}>
          <div style={inner(760)}>
            <Typography style={eyebrow()}>FAQ</Typography>
            <Typography variant="h4" component="h2" style={sectionHeading(26)}>
              Frequently Asked Questions
            </Typography>

            {FAQ_ITEMS.map((item, i) => (
              <div key={i} style={card({ marginBottom: 16 })}>
                <Typography style={{ fontSize: 17, fontWeight: 700, color: GREEN, marginBottom: 10 }}>
                  {item.q}
                </Typography>
                <Typography style={{ fontSize: 16, color: '#333', lineHeight: 1.75 }}>
                  {item.a}
                </Typography>
              </div>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            ORDER CTA — hidden until ready to sell
        ══════════════════════════════════════════════════════════════ */}
        <div style={{ display: 'none' }}>
          <div style={section(GREEN_LIGHT, '60px 0')}>
            <div style={{ ...inner(500), textAlign: 'center' }}>
              <Typography variant="h4" style={{ fontSize: 24, fontWeight: 700, color: DARK, marginBottom: 24 }}>
                Ready to Try {MainConstants.APPLICATION_NAME}&trade;?
              </Typography>
              <div style={{ marginBottom: 20 }}>
                <ReCAPTCHA
                  sitekey={MainConstants.RECAPTCHASITEKEY}
                  size="normal"
                  ref={this.recaptchaRef}
                  onChange={this.handleCaptchaChange}
                  badge="bottomright"
                  style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }} />
              </div>
              <Button variant="contained" color="primary" onClick={this.handleShowOrderFormChange}
                style={{ backgroundColor: GREEN, color: 'white', fontSize: 20, padding: '14px 48px', textTransform: 'none', borderRadius: 6, width: '100%' }}>
                Place a Purchase Order
              </Button>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            REQUEST A SAMPLE CTA
        ══════════════════════════════════════════════════════════════ */}
        <div style={section(GREEN_LIGHT, '60px 0')}>
          <div style={{ ...inner(540), textAlign: 'center' }}>
            <Typography style={eyebrow()}>Early Access</Typography>
            <Typography variant="h4" component="h2" style={{ ...sectionHeading(26), marginBottom: 16 }}>
              Want to Try {MainConstants.APPLICATION_NAME}&trade;?
            </Typography>
            <Typography style={{ fontSize: 17, color: GRAY, lineHeight: 1.75, marginBottom: 32 }}>
              We're working with a small group of early users to test Orchima™ and gather feedback.
              If you're interested, fill out a short form and we'll be in touch.
            </Typography>
            <RouterLink to="/requestsample" style={{ textDecoration: 'none' }}>
              <Button variant="contained"
                style={{ backgroundColor: GREEN, color: '#ffffff', fontSize: 17, padding: '13px 44px', textTransform: 'none', borderRadius: 6, boxShadow: '0 2px 10px rgba(26,115,106,0.3)' }}>
                Request a Sample
              </Button>
            </RouterLink>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            FOOTER LINKS
        ══════════════════════════════════════════════════════════════ */}
        <div style={{ backgroundColor: DARK, padding: '48px 0 36px' }}>
          <div style={inner(840)}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 36 }}>
              <img height={110} width={110} src="/static/images/OrchimaLogo2.png" alt="Orchima Logo" style={{ opacity: 0.88 }} />
            </div>

            <Grid container spacing={24}>
              {[
                { label: 'Maintenance',      href: '/orchimacleanup',   text: MainConstants.APPLICATION_NAME + '™ Maintenance' },
                { label: 'Orchid Care',      href: '/orchideducation',  text: 'Orchid Education' },
                { label: 'Common Problems',  href: '/orchidproblems',   text: 'Orchid Challenges' },
                { label: 'Legal',            href: '/disclaimer',       text: 'Product Disclaimer' },
              ].map((link) => (
                <Grid key={link.label} item xs={12} sm={6} md={3}>
                  <Typography style={{ color: '#a8d5b0', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 8 }}>
                    {link.label}
                  </Typography>
                  <Typography style={{ fontSize: 15, lineHeight: 1.7 }}>
                    <a href={link.href} rel="noreferrer" style={{ color: '#ccc', textDecoration: 'none' }}>{link.text}</a>
                  </Typography>
                </Grid>
              ))}
            </Grid>

            <div style={{ marginTop: 32, paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
              <Typography style={{ color: '#a8d5b0', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 10 }}>
                Orchid Organizations
              </Typography>
              <div>
                <div style={{ marginBottom: 8 }}>
                  <a href="https://www.aos.org/" rel="noreferrer" style={{ color: '#ccc', textDecoration: 'none', fontSize: 15 }}>
                    American Orchid Society
                  </a>
                </div>
                <div>
                  <a href="https://www.orchidconservationcoalition.org/" rel="noreferrer" style={{ color: '#ccc', textDecoration: 'none', fontSize: 15 }}>
                    Orchid Conservation Coalition
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            ORDER DIALOG (preserved unchanged)
        ══════════════════════════════════════════════════════════════ */}
        <Dialog
          open={this.state.showOrderDialog}
          onClose={this.handleClickShowOrderDialogClose}
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          maxWidth="md">
          <DialogTitle id="scroll-dialog-title">Order Information</DialogTitle>
          <DialogContent id="orchima-order-dialog"
            style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <CreditCardForm />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClickShowOrderDialogClose} color="secondary"
              style={{ backgroundColor: 'white', border: '2px solid red', color: 'red', borderWidth: '2px', marginRight: 20 }}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}


OrchimaMainPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData: state.login.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    updateUserProfileAction: updateUserProfileAction,
    saveAComment: saveAComment,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchimaMainPage));
